import { STORAGE_KEY_TOKEN } from '../storage-keys'

/**
 * Get token from localStorage
 * @returns {string|null}
 */
export const getToken = () => {
  return localStorage.getItem(STORAGE_KEY_TOKEN)
}

/**
 * Set token to localStorage
 * @param {string} token
 */
export const setToken = (token) => {
  localStorage.setItem(STORAGE_KEY_TOKEN, token)
}

/**
 * Remove token from localStorage
 */
export const removeToken = () => {
  localStorage.removeItem(STORAGE_KEY_TOKEN)
}
